import { Helmet } from 'react-helmet-async';
import Canonical from '../../seo/Canonical';
import { Link } from 'react-router-dom';
import Newsletter from '../Homepage/Newsletter';
import Footer from '../Layouts/Footer';
import ContactForm from '../Common/ContactForm';
import './ContactUs.css';

const BUSINESS_PHONE_TEL = "tel:+447404049714";
const BUSINESS_PHONE_DISPLAY = "+44 7404 049714";

const ContactUs = () => {
  return (
    <div className="contact-us-page">
      <Helmet>
        <meta name="keywords" content="contact Pick Pack Pro, fulfilment quote, e-commerce fulfilment UK, Amazon FBA services, UK fulfilment company, get quote" />
        <meta httpEquiv="X-Robots-Tag" content="index, follow" />
        <meta name="publisher" content="Pick Pack Pro" />
      </Helmet>
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />
      <section className="get-quote-section">
        <div className="get-quote-container">
          <div className="get-quote-header">
            <h1 className="get-quote-title">Get a Custom Fulfilment Quote</h1>
            <p className="get-quote-subtitle">
              Tell us about your business, and our team will get back to you within 24 hours with a tailored pricing plan.
            </p>
          </div>
          
          <div className="get-quote-content">
            <div className="quote-form-wrapper">
              <ContactForm source="contact-fulfillment-services" />
            </div>
            
            <div className="schedule-call-cta">
              <div className="schedule-call-card">
                <div className="schedule-card-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="14" fill="#e8f5e9"/>
                    <path d="M16 14h16a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2z" stroke="#2e7d32" strokeWidth="2"/>
                    <path d="M20 10v8M28 10v8M14 22h20" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <h2 className="schedule-card-title">Pick Your Slot</h2>
                <p className="schedule-card-subtitle">Choose a date and time that suits you best.</p>
                <Link to="/book-a-free-call" className="schedule-call-btn">
                  Book a Call
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
                <p className="schedule-card-note">No credit card required � Completely free</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Details Section */}
      <section className="contact-details-section">
        <div className="contact-details-container">
          <div className="contact-details-row">
            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="contact-detail-content">
                <h2 className="contact-detail-label">Email</h2>
                <a href="mailto:info@pickpackpro.co.uk" className="contact-detail-value">info@pickpackpro.co.uk</a>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="contact-detail-content">
                <h2 className="contact-detail-label">Location</h2>
                <p className="contact-detail-value">
                  Unit 36 Tanners Drive, Blakelands,<br />Milton Keynes MK14 5BN
                </p>
              </div>
            </div>

            <div className="contact-detail-item">
              <div className="contact-detail-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="contact-detail-content">
                <h2 className="contact-detail-label">Phone</h2>
                <a href={BUSINESS_PHONE_TEL} className="contact-detail-value">{BUSINESS_PHONE_DISPLAY}</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2452.180483859829!2d-0.7432286234454186!3d52.07644427194831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a335aa92f14a4f9%3A0x4f336b3fed46f6ae!2sPick%20Pack%20Pro!5e0!3m2!1sen!2s!4v1772719210899!5m2!1sen!2s"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Pick Pack Pro Location"
        ></iframe>
      </section>

      <Newsletter />
      <Footer />
    </div>
  );
};

export default ContactUs;
